import arrangeIntoDisjointColumns from './arrangeIntoDisjointColumns';
import ColumnEvent from '../schema/ColumnEvent';
import ConflictGroup from '../schema/ConflictGroup';
import ConflictGroupColumns from '../schema/ConflictGroupColumns';
import DayViewItem from 'mini-day-view/lib/schema/DayViewItem';
import normaliseEvents from './normaliseEvents';
import orderedEventListToConflictGroupList from './orderedEventListToConflictGroupList';
import TimeConstants from 'mini-datetime-utils/lib/dateValues/TimeConstants';
import { CalendarEvent } from 'mini-calendar-event-types';
import { startOfDay, getTimestamp } from 'owa-datetime';

/**
 * Takes an ordered set of calendar events and returns the dayViewItems from that to be placed in the day view
 * @param events
 */
const convertCalendarEventsToDayViewItems = (
    events: CalendarEvent[]
): DayViewItem<CalendarEvent>[] => {
    const dayViewItems: DayViewItem<CalendarEvent>[] = [];
    orderedEventListToConflictGroupList(
        normaliseEvents(events && events.filter(event => !event.IsEffectiveAllDayEvent))
    ).forEach((conflictGroup: ConflictGroup) => {
        const conflictGroupColumns: ConflictGroupColumns = arrangeIntoDisjointColumns(
            conflictGroup
        );
        if (conflictGroupColumns) {
            const { columns } = conflictGroupColumns;

            const column: number = columns.length;
            columns.forEach((currentColumn: ColumnEvent[]) => {
                dayViewItems.push(
                    ...currentColumn.map(
                        (columnEvent: ColumnEvent): DayViewItem<CalendarEvent> => {
                            const {
                                event: { start, end, event },
                                startColumn: left,
                                endColumn: right,
                            } = columnEvent;
                            const top: number =
                                Math.ceil(
                                    (getTimestamp(start) - getTimestamp(startOfDay(start))) /
                                        TimeConstants.MillisecondsIn1Min
                                ) + 1;
                            const height: number =
                                Math.ceil(
                                    (getTimestamp(end) - getTimestamp(start)) /
                                        TimeConstants.MillisecondsIn1Min
                                ) - 1; // 1 is the buffer margin

                            return {
                                event,
                                column,
                                layout: {
                                    top,
                                    height,
                                    left,
                                    right,
                                },
                            };
                        }
                    )
                );
            });
        }
    });

    return dayViewItems;
};

export default convertCalendarEventsToDayViewItems;
